// Dependencies
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as oidcReducer } from 'redux-oidc';

// Reducers
import SelectedFormReducer from 'reducers/SelectedFormReducer';
import SelectedSubmissionReducer from 'reducers/SelectedSubmissionReducer';
import ServiceStateReducer from 'reducers/ServiceStateReducer';
import SnackbarMessageReducer from 'reducers/SnackbarMessageReducer';
import SnackbarLastInitReducer from 'reducers/SnackbarLastInitReducer';
import SnackbarVisibleReducer from 'reducers/SnackbarVisibleReducer';
import ValidationMessagesReducer from 'reducers/ValidationMessagesReducer';
import IsValidatedReducer from 'reducers/IsValidatedReducer';
import IsSavingDataReducer from 'reducers/IsSavingDataReducer';
import IsEditedReducer from 'reducers/IsEditedReducer';
import LoadingMessageReducer from 'reducers/LoadingMessageReducer';
import LastInteractionAtReducer from 'reducers/LastInteractionAtReducer';

const reducers = history => combineReducers({
  router: connectRouter(history),
  oidc: oidcReducer,
  selectedForm: SelectedFormReducer,
  selectedSubmission: SelectedSubmissionReducer,
  serviceState: ServiceStateReducer,
  snackbarMessage: SnackbarMessageReducer,
  snackbarLastInit: SnackbarLastInitReducer,
  snackbarVisible: SnackbarVisibleReducer,
  validationMessages: ValidationMessagesReducer,
  isValidated: IsValidatedReducer,
  isSavingData: IsSavingDataReducer,
  isEdited: IsEditedReducer,
  loadingMessage: LoadingMessageReducer,
  lastInteractionAt: LastInteractionAtReducer
});

export default reducers;
